import { render, staticRenderFns } from "./browser.vue?vue&type=template&id=6552dc38&scoped=true&"
import script from "./browser.vue?vue&type=script&lang=js&"
export * from "./browser.vue?vue&type=script&lang=js&"
import style0 from "./browser.vue?vue&type=style&index=0&id=6552dc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6552dc38",
  null
  
)

export default component.exports